<template>
  <v-app :class="isPublicPage ? '' : 'background'">
    <v-main>
      <v-container>
        <Loading v-if="!isPublicPage && userStore.loading" />
        <Impersonate v-if="!isPublicPage" />
        <Header v-if="!isPublicPage" />
        <Nav v-if="!isPublicPage" />
        <router-view />
        <Footer v-if="!isPublicPage" />
      </v-container>
    </v-main>
  </v-app>
</template>

<script setup>
import { useUserStore } from "./store/user";
import { useYearStore } from "./store/yearStore";
import { computed, onBeforeMount } from "vue";
import { useRoute } from "vue-router/composables";
import Loading from "@/components/layout/Loading.vue";
import Header from "@/components/layout/Header.vue";
import Nav from "@/components/layout/Nav.vue";
import Footer from "@/components/layout/Footer.vue";
import Impersonate from "@/components/layout/Impersonate.vue";
import router from "@/router";
const userStore = useUserStore();
const yearStore = useYearStore();
const route = useRoute();
const isPublicPage = computed(() => {
  return (
    route.name === "currentSelectedSchoolList" ||
    route.name === "publicLineupForm"
  );
});
const pathHasYear = computed(() => {
  return !!route.params.yearId;
});
const yearId = computed(() => {
  return parseInt(route.params.yearId);
});

onBeforeMount(async () => {
  if (!isPublicPage.value) await userStore.fetchUser();
  // fetch years if its empty.
  if (!yearStore.years || yearStore.years.length === 0)
    await yearStore.fetchYears(!isPublicPage.value);
  if (pathHasYear.value) {
    await yearStore.setYearById(yearId.value);
  }
  // if there was last url, redirect to it , if we have logged in now.
  let lastUrl = "";
  if (
    (lastUrl = sessionStorage.getItem("last_url_tennis")) &&
    userStore.isLoggedIn
  ) {
    // Remove the base URL from the stored URL
    const baseUrl = window.location.origin;
    const relativePath = lastUrl.replace(baseUrl, "");
    sessionStorage.removeItem("last_url_tennis");
    await router.push({ path: relativePath });
  }
});
</script>

<style lang="scss">
@import "nprogress/nprogress";
</style>
